import { z } from 'zod';
import { baseObjectSchema, baseSchema } from '../baseSchemas';

// DCMeasurementUnit schema
export const dcMeasurementUnitSchema = baseObjectSchema.extend({
  measurementUnitId: z.string(),
  representativeId: z.string(),
  measurementUnitRemotedCode: z.string(),
  measurementUnit: baseSchema.optional(),
});

export const getDCMeasurementUnitsResponseSchema = z.object({
  data: z.array(dcMeasurementUnitSchema),
});

export type GetDCMeasurementUnitsResponse = z.infer<typeof getDCMeasurementUnitsResponseSchema>;
